import type { Map, MapMouseEvent, MapTouchEvent } from 'mapbox-gl';
import type { BdMapControls } from './controls.model';

export class BdMapClickEvent {
  constructor(
    public mapEvent: MapMouseEvent | MapTouchEvent,
    public map: Map,
    public controls: BdMapControls,
    public propagate = true,
  ) {}
}
